import IComprovanteTransferenciaDTO from '../entities/IComprovanteTransferencia'
import { ITransferenciaRepository } from '../repositories/ITransferenciaRepository'

export interface IComprovanteTransferencia {
  execute(data: IComprovanteTransferenciaDTO): Promise<ArrayBuffer>
}
export default class ComprovanteTransferenciaImpl
  implements IComprovanteTransferencia
{
  constructor(
    private readonly transferenciaRepository: ITransferenciaRepository,
  ) {}

  async execute(data: IComprovanteTransferenciaDTO): Promise<ArrayBuffer> {
    return this.transferenciaRepository.getComprovante(data)
  }
}
